<template>
  <div>
    <div :style="{ paddingTop: '20px', paddingBottom: '5px'}">
      <span :style="{ fontSize: '19px', fontWeight: 'bold'}">{{title}}</span>
      <span :style="getKamokuPassStyle()">{{this.passed ? 'OK' : 'NG'}} {{this.credit | decimal}} / {{limit[0] | decimal}}~{{limit[1] | decimal}}</span>
    </div>
    <div v-for="item in list" :key="item.id">
      <div class="grid3">
        <div class="grid3-cell">
          <div>{{item.label}}</div>
        </div>
        <div class="grid3-cell2" :style="getPassStyle(item)">
          <div v-if="item.cource.resultInfo.limit[0] != item.cource.resultInfo.limit[1]">{{item.cource.resultInfo.credit | decimal}} / {{item.cource.resultInfo.limit[0] | decimal}}~{{item.cource.resultInfo.limit[1] | decimal}}</div>
          <div v-else>{{item.cource.resultInfo.credit | decimal}} / {{item.cource.resultInfo.limit[0] | decimal}}</div>
        </div>
      </div>
      <div v-for="c in item.cource.credits" :key="c.index">
        <div class="grid2">
          <div class="grid2-cell">
            <div v-if="c.original" :style="{color: 'purple'}">{{c.original.科目番号}} {{c.original.科目名}} ({{c.科目番号}} {{c.科目名}}に読替)</div>
            <div v-else>{{c.科目番号}} {{c.科目名}}</div>
          </div>
          <div class="grid2-cell2" :style="getRatingStyle(c)">
            <div>{{c.単位数 | decimal}} ({{c.総合評価}})</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DecimalFilter} from '@/components/mixins/DecimalFilter'
import * as R from 'ramda'
export default {
  name: 'result-credit-view',
  mixins: [DecimalFilter],
  props: {
    title: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true,
      validator: function (value) {
        const hasAllProps = R.allPass([R.has('list'), R.has('passed'), R.has('credit'), R.has('limit')])
        const result = hasAllProps(value)
        return result
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {
    passed () { return this.item.passed},
    list () { return this.item.list},
    limit () { return this.item.limit },
    credit () { return this.item.credit },
  },
  methods: {
    getPassStyle (i) {
      const passed = i.cource.resultInfo.passed
      return {color: passed ? '#7573B1' : 'red'}
    },
    getRatingStyle (credit) {
      if (credit.総合評価 === '履修中') {
        return { color: 'red'}
      } else {
        // return { color: 'black'}
        return null
      }
    },
    getKamokuPassStyle () {
      const passed = this.passed
      return {
        fontWeight: 'bold',
        paddingLeft: '6px',
        color: passed ? '#7573B1' : 'red'
      }
    }
  }
}
</script>

<style>
.grid2 {
  display: flex;
  line-height: 1.5;
}
.grid2-cell {
  flex: 1;
  /* background-color: bisque; */
  padding-left: 20px
}
.grid2-cell2 {
  /* background-color: cadetblue; */
  /* text-align: center; */
  text-align: right;
  /* width: 60px; */
  width: 80px;
}

.grid3 {
  display: flex;
  line-height: 1;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold
}
.grid3-cell {
  flex: 1;
  /* background-color: bisque; */
  padding-left: 10px;
  font-size: 13px;
  color: #7573B1;
}
.grid3-cell2 {
  /* background-color: cadetblue; */
  /* width: 80px; */
  width: 110px;
  align-self: center;
  /* text-align: center; */
  text-align: right;
  padding-right: 5px;
}

@media print {
  /* .grid3-cell { */
    /* flex: 1; */
    /* background-color: bisque; */
    /* padding-left: 10px; */
    /* font-size: 5px; */
    /* color: #7573B1; */
  /* } */
}
</style>
